const PREVIEW_COUNT = 5;

export interface NotificationPreview<T> {
    shown: T[];
    hiddenCount: number;
}

export function previewNotifications<T>(set: T[], expanded: boolean): NotificationPreview<T> {
    const shown = expanded ? set : set.slice(0, PREVIEW_COUNT);
    return { shown, hiddenCount: set.length - shown.length };
}
